package com.shadowings.gero.presentation.screen

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.PrimaryTabRow
import androidx.compose.material3.Surface
import androidx.compose.material3.Tab
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.datasource.compendioRules
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.CompendioRuleItem
import com.shadowings.gero.domain.model.LessonIds
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.ImagePopup
import com.shadowings.gero.presentation.model.LandingUiState
import com.shadowings.gero.presentation.model.Word
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import com.shadowings.gero.util.systemLanguageCode
import compose.icons.FeatherIcons
import compose.icons.feathericons.Search
import compose.icons.feathericons.X
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.ab01
import gero.composeapp.generated.resources.ab02
import gero.composeapp.generated.resources.ab03
import gero.composeapp.generated.resources.ab05
import gero.composeapp.generated.resources.ab06
import gero.composeapp.generated.resources.ab08
import gero.composeapp.generated.resources.ab14
import gero.composeapp.generated.resources.ab15
import gero.composeapp.generated.resources.ab18
import gero.composeapp.generated.resources.ab20
import gero.composeapp.generated.resources.ab22
import gero.composeapp.generated.resources.ab23
import gero.composeapp.generated.resources.ab24
import gero.composeapp.generated.resources.ab27
import gero.composeapp.generated.resources.ab29
import gero.composeapp.generated.resources.ri00182
import gero.composeapp.generated.resources.ri00200
import gero.composeapp.generated.resources.acqua
import gero.composeapp.generated.resources.amenamhat
import gero.composeapp.generated.resources.cielo
import gero.composeapp.generated.resources.clear_search_desc
import gero.composeapp.generated.resources.exp_content_royal_names_img_amenemhat
import gero.composeapp.generated.resources.exp_content_vocab_animali_miit
import gero.composeapp.generated.resources.exp_content_vocab_cibo_acqua
import gero.composeapp.generated.resources.exp_content_vocab_umani_scriba
import gero.composeapp.generated.resources.exp_content_vocab_vari_2_cielo
import gero.composeapp.generated.resources.exp_content_vocab_varie_re_basso
import gero.composeapp.generated.resources.inpu
import gero.composeapp.generated.resources.iten
import gero.composeapp.generated.resources.mentuhotep
import gero.composeapp.generated.resources.miit
import gero.composeapp.generated.resources.neferhotep
import gero.composeapp.generated.resources.no_hiero_found
import gero.composeapp.generated.resources.no_rule_found
import gero.composeapp.generated.resources.no_word_found
import gero.composeapp.generated.resources.osiride
import gero.composeapp.generated.resources.ptah
import gero.composeapp.generated.resources.ramses
import gero.composeapp.generated.resources.re_basso
import gero.composeapp.generated.resources.roast
import gero.composeapp.generated.resources.roast_reading
import gero.composeapp.generated.resources.scribe
import gero.composeapp.generated.resources.search_compendium_placeholder
import gero.composeapp.generated.resources.search_icon_desc
import gero.composeapp.generated.resources.tab_favorites
import gero.composeapp.generated.resources.tab_hieroglyphs
import gero.composeapp.generated.resources.tab_hieroglyphs_short
import gero.composeapp.generated.resources.tab_images
import gero.composeapp.generated.resources.tab_locked
import gero.composeapp.generated.resources.tab_rules
import gero.composeapp.generated.resources.tab_unlocked
import gero.composeapp.generated.resources.tab_words
import gero.composeapp.generated.resources.tale_1_12
import gero.composeapp.generated.resources.tutankhamon
import gero.composeapp.generated.resources.tutankhamon2
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

// Struttura dati per ordinamento dei codici Gardiner
private data class GardinerCodeParts(
    val prefix: String,
    val number: Int,
    val suffix: String
) : Comparable<GardinerCodeParts> {
    override fun compareTo(other: GardinerCodeParts): Int {
        val prefixComp = this.prefix.compareTo(other.prefix)
        if (prefixComp != 0) return prefixComp

        val numComp = this.number.compareTo(other.number)
        if (numComp != 0) return numComp

        return this.suffix.compareTo(other.suffix)
    }
}

private fun parseGardinerCode(code: String): GardinerCodeParts {
    val prefix =
        if (code.startsWith("Aa", ignoreCase = true)) "Aa" else code.takeWhile { it.isLetter() }
    val remaining = code.substring(prefix.length)
    val numberStr = remaining.takeWhile { it.isDigit() }
    val number = numberStr.toIntOrNull() ?: 0
    val suffix = remaining.substring(numberStr.length)
    return GardinerCodeParts(prefix, number, suffix)
}

private data class CompendioImageItem(
    val id: String,
    val image: DrawableResource,
    val lessonId: String,
    val titleIt: String,
    val titleEn: String,
    val titleDe: String = titleEn,
    val titleEs: String = titleEn,
    val description: StringResource? = null
)

private fun CompendioImageItem.title(languageCode: String): String = when {
    languageCode.startsWith("it") -> titleIt
    languageCode.startsWith("de") -> titleDe
    languageCode.startsWith("es") -> titleEs
    else -> titleEn
}

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun CompendioScreenContent(
    uiState: LandingUiState,
    seenHieroCodes: Set<String>,
    seenWordIds: Set<String>,
    onToggleFavoriteHiero: (String) -> Unit,
    onToggleFavoriteWord: (String) -> Unit,
    onWordViewed: (Word) -> Unit,
    onHieroViewed: (Hiero) -> Unit,
    onRuleClick: (String) -> Unit = {},
    onTabSelected: (Int) -> Unit = {},
    modifier: Modifier = Modifier
) {
    val languageCode = uiState.userData.language.ifBlank { systemLanguageCode() }
    val compendioImages = remember {
        listOf(
            CompendioImageItem("ptah", Res.drawable.ptah, LessonIds.FAMOUS_NAMES, "Ptah", "Ptah"),
            CompendioImageItem("inpu", Res.drawable.inpu, LessonIds.FAMOUS_NAMES, "Inpu", "Inpu"),
            CompendioImageItem("iten", Res.drawable.iten, LessonIds.FAMOUS_NAMES, "Iten", "Aten"),
            CompendioImageItem(
                id = "miit",
                image = Res.drawable.miit,
                lessonId = LessonIds.VOCAB_ANIMALS,
                titleIt = "Gatta",
                titleEn = "She-cat",
                titleDe = "Katze",
                titleEs = "Gata",
                description = Res.string.exp_content_vocab_animali_miit
            ),
            CompendioImageItem(
                id = "scribe",
                image = Res.drawable.scribe,
                lessonId = LessonIds.VOCAB_HUMANS,
                titleIt = "Scriba",
                titleEn = "Scribe",
                titleDe = "Schreiber",
                titleEs = "Escriba",
                description = Res.string.exp_content_vocab_umani_scriba
            ),
            CompendioImageItem(
                id = "acqua",
                image = Res.drawable.acqua,
                lessonId = LessonIds.VOCAB_FOOD,
                titleIt = "Acqua",
                titleEn = "Water",
                titleDe = "Wasser",
                titleEs = "Agua",
                description = Res.string.exp_content_vocab_cibo_acqua
            ),
            CompendioImageItem(
                id = "re_basso",
                image = Res.drawable.re_basso,
                lessonId = LessonIds.VOCAB_VARIE,
                titleIt = "Re del Basso Egitto",
                titleEn = "King of Lower Egypt",
                titleDe = "König von Unterägypten",
                titleEs = "Rey del Bajo Egipto",
                description = Res.string.exp_content_vocab_varie_re_basso
            ),
            CompendioImageItem(
                id = "cielo",
                image = Res.drawable.cielo,
                lessonId = LessonIds.VOCAB_VARI_2,
                titleIt = "Cielo",
                titleEn = "Sky",
                titleDe = "Himmel",
                titleEs = "Cielo",
                description = Res.string.exp_content_vocab_vari_2_cielo
            ),
            CompendioImageItem(
                id = "amenamhat",
                image = Res.drawable.amenamhat,
                lessonId = LessonIds.ROYAL_NAMES,
                titleIt = "Amenemhat",
                titleEn = "Amenemhat",
                description = Res.string.exp_content_royal_names_img_amenemhat
            ),
            CompendioImageItem(
                "mentuhotep",
                Res.drawable.mentuhotep,
                LessonIds.ROYAL_NAMES,
                "Mentuhotep",
                "Mentuhotep"
            ),
            CompendioImageItem(
                "neferhotep",
                Res.drawable.neferhotep,
                LessonIds.ROYAL_NAMES,
                "Neferhotep",
                "Neferhotep"
            ),
            CompendioImageItem(
                "tutankhamon",
                Res.drawable.tutankhamon,
                LessonIds.ROYAL_NAMES,
                titleIt = "Tutankhamon",
                titleEn = "Tutankhamun",
                titleDe = "Tutanchamun",
                titleEs = "Tutankamón"
            ),
            CompendioImageItem(
                id = "tutankhamon2",
                image = Res.drawable.tutankhamon2,
                lessonId = LessonIds.ROYAL_NAMES,
                titleIt = "Tutankhamon II",
                titleEn = "Tutankhamun II",
                titleDe = "Tutanchamun II",
                titleEs = "Tutankamón II"
            ),
            CompendioImageItem(
                id = "roast",
                image = Res.drawable.roast,
                lessonId = LessonIds.PARTICLE_IW,
                titleIt = "Scena nella tomba di Nomarch Ukhhotep a Meir",
                titleEn = "Scene in the tomb of Nomarch Ukhhotep at Meir",
                titleDe = "Szene im Grab des Nomarchen Ukhhotep in Meir",
                titleEs = "Escena en la tumba del nomarca Ukhhotep en Meir"
            ),
            CompendioImageItem(
                id = "roast_reading",
                image = Res.drawable.roast_reading,
                lessonId = LessonIds.PARTICLE_IW,
                titleIt = "Ordine di lettura della prima frase",
                titleEn = "Reading order of the first sentence",
                titleDe = "Leseordnung des ersten Satzes",
                titleEs = "Orden de lectura de la primera frase"
            ),
            CompendioImageItem(
                id = "osiride",
                image = Res.drawable.osiride,
                lessonId = LessonIds.VOCAB_DEI_SOVRANI,
                titleIt = "",
                titleEn = "",
                titleDe = "",
                titleEs = ""
            ),
            CompendioImageItem(
                id = "ramses",
                image = Res.drawable.ramses,
                lessonId = LessonIds.VOCAB_DEI_SOVRANI,
                titleIt = "",
                titleEn = "",
                titleDe = "",
                titleEs = ""
            ),
            CompendioImageItem(
                id = "ship-1",
                image = Res.drawable.tale_1_12,
                lessonId = LessonIds.IL_SEGRETO_DELLA_PIRAMIDE,
                titleIt = "",
                titleEn = "",
                titleDe = "",
                titleEs = ""
            ),
            CompendioImageItem(
                id = "ab01",
                image = Res.drawable.ab01,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Meni",
                titleEn = "Meni",
                titleDe = "Meni",
                titleEs = "Meni"
            ),
            CompendioImageItem(
                id = "ab02",
                image = Res.drawable.ab02,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Teti",
                titleEn = "Teti",
                titleDe = "Teti",
                titleEs = "Teti"
            ),
            CompendioImageItem(
                id = "ab03",
                image = Res.drawable.ab03,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Iti",
                titleEn = "Iti",
                titleDe = "Iti",
                titleEs = "Iti"
            ),
            CompendioImageItem(
                id = "ab05",
                image = Res.drawable.ab05,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Septi",
                titleEn = "Septi",
                titleDe = "Septi",
                titleEs = "Septi"
            ),
            CompendioImageItem(
                id = "ab06",
                image = Res.drawable.ab06,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Meribiap",
                titleEn = "Meribiap",
                titleDe = "Meribiap",
                titleEs = "Meribiap"
            ),
            CompendioImageItem(
                id = "ab08",
                image = Res.drawable.ab08,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Qebeh",
                titleEn = "Qebeh",
                titleDe = "Qebeh",
                titleEs = "Qebeh"
            ),
            CompendioImageItem(
                id = "ab14",
                image = Res.drawable.ab14,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Diadiay",
                titleEn = "Diadiay",
                titleDe = "Diadiay",
                titleEs = "Diadiay"
            ),
            CompendioImageItem(
                id = "ab15",
                image = Res.drawable.ab15,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Nebka",
                titleEn = "Nebka",
                titleDe = "Nebka",
                titleEs = "Nebka"
            ),
            CompendioImageItem(
                id = "ab18",
                image = Res.drawable.ab18,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Sedjes",
                titleEn = "Sedjes",
                titleDe = "Sedjes",
                titleEs = "Sedjes"
            ),
            CompendioImageItem(
                id = "ab20",
                image = Res.drawable.ab20,
                lessonId = LessonIds.NOMI_IMPORTANTI,
                titleIt = "Sneferu",
                titleEn = "Sneferu",
                titleDe = "Snofru",
                titleEs = "Snefru"
            ),
            CompendioImageItem(
                id = "ab22",
                image = Res.drawable.ab22,
                lessonId = LessonIds.TRADUCIAMO_I_NOMI,
                titleIt = "Diedefre",
                titleEn = "Djedefre",
                titleDe = "Djedefre",
                titleEs = "Dyedefra"
            ),
            CompendioImageItem(
                id = "ab23",
                image = Res.drawable.ab23,
                lessonId = LessonIds.TRADUCIAMO_I_NOMI,
                titleIt = "Khafre",
                titleEn = "Khafre",
                titleDe = "Chephren",
                titleEs = "Kefrén"
            ),
            CompendioImageItem(
                id = "ab24",
                image = Res.drawable.ab24,
                lessonId = LessonIds.TRADUCIAMO_I_NOMI,
                titleIt = "Menkaure",
                titleEn = "Menkaure",
                titleDe = "Mykerinos",
                titleEs = "Micerino"
            ),
            CompendioImageItem(
                id = "ab27",
                image = Res.drawable.ab27,
                lessonId = LessonIds.TRADUCIAMO_I_NOMI,
                titleIt = "Sahure",
                titleEn = "Sahure",
                titleDe = "Sahure",
                titleEs = "Sahura"
            ),
            CompendioImageItem(
                id = "ab29",
                image = Res.drawable.ab29,
                lessonId = LessonIds.TRADUCIAMO_I_NOMI,
                titleIt = "Neferefre",
                titleEn = "Neferefre",
                titleDe = "Neferefre",
                titleEs = "Neferefra"
            ),
            CompendioImageItem(
                id = "ri00182",
                image = Res.drawable.ri00182,
                lessonId = LessonIds.NOMI_NOMI_NOMI,
                titleIt = "Menkaure",
                titleEn = "Menkaure",
                titleDe = "Mykerinos",
                titleEs = "Micerino"
            ),
            CompendioImageItem(
                id = "ri00200",
                image = Res.drawable.ri00200,
                lessonId = LessonIds.NOMI_NOMI_NOMI,
                titleIt = "Intef",
                titleEn = "Intef",
                titleDe = "Antef",
                titleEs = "Intef"
            ),
        )
    }

    // Definizione delle categorie Gardiner localizzate
    val gardinerCategories = remember(languageCode) {
        when {
            languageCode.startsWith("it") -> listOf(
                "A" to "A. Uomo e sue occupazioni",
                "B" to "B. Donna e sue occupazioni",
                "C" to "C. Divinità antropomorfe",
                "D" to "D. Parti del corpo umano",
                "E" to "E. Mammiferi",
                "F" to "F. Parti di mammiferi",
                "G" to "G. Uccelli",
                "H" to "H. Parti di uccelli",
                "I" to "I. Animali anfibi, rettili, ecc.",
                "K" to "K. Pesci e parti di pesci",
                "L" to "L. Invertebrati e piccoli animali",
                "M" to "M. Alberi e piante",
                "N" to "N. Cielo, terra, acqua",
                "O" to "O. Edifici, parti di edifici, ecc.",
                "P" to "P. Imbarcazioni e parti di imbarcazioni",
                "Q" to "Q. Arredamento domestico e funerario",
                "R" to "R. Arredi del tempio ed emblemi sacri",
                "S" to "S. Corone, abbigliamento, scettri, ecc.",
                "T" to "T. Guerra, caccia e macelleria",
                "U" to "U. Agricoltura, artigianato e professioni",
                "V" to "V. Corde, fibre, cesti, borse, ecc.",
                "W" to "W. Vasi di pietra e terracotta",
                "X" to "X. Pane e dolciumi",
                "Y" to "Y. Scrittura, giochi, musica",
                "Z" to "Z. Tratti, segni derivati dallo ieratico, figure geometriche",
                "Aa" to "Aa. Non classificati"
            )

            languageCode.startsWith("de") -> listOf(
                "A" to "A. Mann und seine Berufe",
                "B" to "B. Frau und ihre Berufe",
                "C" to "C. Anthropomorphe Gottheiten",
                "D" to "D. Teile des menschlichen Körpers",
                "E" to "E. Säugetiere",
                "F" to "F. Teile von Säugetieren",
                "G" to "G. Vögel",
                "H" to "H. Teile von Vögeln",
                "I" to "I. Amphibien, Reptilien usw.",
                "K" to "K. Fische und Fischteile",
                "L" to "L. Wirbellose und Kleintiere",
                "M" to "M. Bäume und Pflanzen",
                "N" to "N. Himmel, Erde, Wasser",
                "O" to "O. Gebäude, Gebäudeteile usw.",
                "P" to "P. Schiffe und Schiffsteile",
                "Q" to "Q. Haus- und Grabmöbel",
                "R" to "R. Tempelgeräte und heilige Embleme",
                "S" to "S. Kronen, Kleidung, Zepter usw.",
                "T" to "T. Krieg, Jagd und Schlachten",
                "U" to "U. Landwirtschaft, Handwerk und Berufe",
                "V" to "V. Seile, Fasern, Körbe, Taschen usw.",
                "W" to "W. Stein- und Tongefäße",
                "X" to "X. Brot und Gebäck",
                "Y" to "Y. Schrift, Spiele, Musik",
                "Z" to "Z. Striche, vom Hieratischen abgeleitete Zeichen, geometrische Figuren",
                "Aa" to "Aa. Unklassifiziert"
            )

            languageCode.startsWith("es") -> listOf(
                "A" to "A. El hombre y sus ocupaciones",
                "B" to "B. La mujer y sus ocupaciones",
                "C" to "C. Divinidades antropomorfas",
                "D" to "D. Partes del cuerpo humano",
                "E" to "E. Mamíferos",
                "F" to "F. Partes de mamíferos",
                "G" to "G. Aves",
                "H" to "H. Partes de aves",
                "I" to "I. Animales anfibios, reptiles, etc.",
                "K" to "K. Peces y partes de peces",
                "L" to "L. Invertebrados y animales pequeños",
                "M" to "M. Árboles y plantas",
                "N" to "N. Cielo, tierra, agua",
                "O" to "O. Edificios, partes de edificios, etc.",
                "P" to "P. Embarcaciones y partes de embarcaciones",
                "Q" to "Q. Mobiliario doméstico y funerario",
                "R" to "R. Mobiliario del templo y emblemas sagrados",
                "S" to "S. Coronas, vestimenta, cetros, etc.",
                "T" to "T. Guerra, caza y carnicería",
                "U" to "U. Agricultura, artesanía y profesiones",
                "V" to "V. Cuerdas, fibras, cestas, bolsas, etc.",
                "W" to "W. Vasijas de piedra y cerámica",
                "X" to "X. Panes y pasteles",
                "Y" to "Y. Escritura, juegos, música",
                "Z" to "Z. Trazos, signos derivados del hierático, figuras geométricas",
                "Aa" to "Aa. No clasificados"
            )

            else -> listOf(
                "A" to "A. Man and his occupations",
                "B" to "B. Woman and her occupations",
                "C" to "C. Anthropomorphic deities",
                "D" to "D. Parts of the human body",
                "E" to "E. Mammals",
                "F" to "F. Parts of mammals",
                "G" to "G. Birds",
                "H" to "H. Parts of birds",
                "I" to "I. Amphibious animals, reptiles, etc.",
                "K" to "K. Fish and parts of fish",
                "L" to "L. Invertebrates and small animals",
                "M" to "M. Trees and plants",
                "N" to "N. Sky, earth, water",
                "O" to "O. Buildings, parts of buildings, etc.",
                "P" to "P. Ships and parts of ships",
                "Q" to "Q. Domestic and funerary furniture",
                "R" to "R. Temple furnishings and sacred emblems",
                "S" to "S. Crowns, clothing, scepters, etc.",
                "T" to "T. Warfare, hunting, butchery",
                "U" to "U. Agriculture, crafts and professions",
                "V" to "V. Rope, fiber, baskets, bags, etc.",
                "W" to "W. Stone and earthenware vessels",
                "X" to "X. Bread and cakes",
                "Y" to "Y. Writing, games, music",
                "Z" to "Z. Strokes, signs derived from hieratic, geometric figures",
                "Aa" to "Aa. Unclassified"
            )
        }
    }

    // Stato dei tab superiore: 0 Geroglifici, 1 Parole, 2 Regole, 3 Immagini.
    // rememberSaveable (non remember): RuleDetailScreen ora è una vera schermata nel
    // NavHost, non un Dialog, quindi CompendioScreenContent viene tolto dalla
    // composizione mentre è aperta e ricreato al ritorno - senza Saveable si
    // perderebbero tab/filtri/ricerca selezionati.
    var selectedTab by rememberSaveable { mutableStateOf(0) }

    // Stati dei filtri chip
    var showOnlyFavorites by rememberSaveable { mutableStateOf(false) }
    var showOnlySeen by rememberSaveable { mutableStateOf(false) }
    var showOnlyLocked by rememberSaveable { mutableStateOf(false) }

    // Ricerca
    var searchQuery by rememberSaveable { mutableStateOf("") }

    // Dialogo dettagli
    var activeHieroDetails by remember { mutableStateOf<Hiero?>(null) }
    var activeWordDetails by remember { mutableStateOf<Word?>(null) }
    var activeImage by remember { mutableStateOf<CompendioImageItem?>(null) }
    val showImagePopup = remember { mutableStateOf(false) }

    LaunchedEffect(activeWordDetails) {
        activeWordDetails?.let { onWordViewed(it) }
    }

    LaunchedEffect(activeHieroDetails) {
        activeHieroDetails?.let { onHieroViewed(it) }
    }

    val compendioWords = remember(uiState.words) {
        uiState.words.filter { it.showInCompendio }
    }

    fun isWordSeen(word: Word): Boolean {
        return seenWordIds.contains(word.id) ||
                word.isSeen(seenWordIds)
    }

    val seenCompendioWordsCount = remember(seenWordIds, compendioWords) {
        compendioWords.count { isWordSeen(it) }
    }
    val unlockedCompendioImagesCount = remember(uiState.userData.stars) {
        compendioImages.count { (uiState.userData.stars[it.lessonId] ?: 0) > 0 }
    }
    val unlockedRulesCount = remember(uiState.userData.stars) {
        compendioRules.count { (uiState.userData.stars[it.lessonId] ?: 0) > 0 }
    }

    val fontScale = LocalDensity.current.fontScale
    val deviceInfo = rememberDeviceInfo()

    Column(modifier = modifier.fillMaxSize().background(MaterialTheme.colorScheme.background)) {
        // Tab Row superiore con conteggi degli elementi visti
        PrimaryTabRow(
            selectedTabIndex = selectedTab,
            modifier = Modifier.fillMaxWidth().semantics { testTag = "compendio_tab_row" }
        ) {
            Tab(
                selected = selectedTab == 0,
                onClick = { selectedTab = 0; onTabSelected(0) },
                modifier = Modifier.semantics { testTag = "compendio_tab_hieroglyphs" },
                text = {
                    Text(
                        text = stringResource(
                            if (fontScale > 1.49f || deviceInfo.deviceClass == DeviceClass.PHONE_SMALL) {
                                Res.string.tab_hieroglyphs_short
                            } else {
                                Res.string.tab_hieroglyphs
                            }
                        ),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        fontWeight = if (selectedTab == 0) FontWeight.Bold else FontWeight.Normal
                    )
                }
            )
            Tab(
                selected = selectedTab == 1,
                onClick = { selectedTab = 1; onTabSelected(1) },
                modifier = Modifier.semantics { testTag = "compendio_tab_words" },
                text = {
                    Text(
                        text = stringResource(Res.string.tab_words),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        fontWeight = if (selectedTab == 1) FontWeight.Bold else FontWeight.Normal
                    )
                }
            )
            Tab(
                selected = selectedTab == 2,
                onClick = { selectedTab = 2; onTabSelected(2) },
                modifier = Modifier.semantics { testTag = "compendio_tab_rules" },
                text = {
                    Text(
                        text = stringResource(Res.string.tab_rules),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        fontWeight = if (selectedTab == 2) FontWeight.Bold else FontWeight.Normal
                    )
                }
            )
            Tab(
                selected = selectedTab == 3,
                onClick = { selectedTab = 3; onTabSelected(3) },
                modifier = Modifier.semantics { testTag = "compendio_tab_images" },
                text = {
                    Text(
                        text = stringResource(Res.string.tab_images),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        fontWeight = if (selectedTab == 3) FontWeight.Bold else FontWeight.Normal
                    )
                }
            )
        }

        val deviceInfo = rememberDeviceInfo()

        // if I'm in smartphone landscape, search and filters must scroll

        if (!deviceInfo.isLandscape || !deviceInfo.isPhone) {
            // Barra di Ricerca Premium
            OutlinedTextField(
                value = searchQuery,
                onValueChange = { searchQuery = it },
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 12.dp),
                placeholder = {
                    Text(
                        stringResource(Res.string.search_compendium_placeholder),
                        style = MaterialTheme.typography.bodyMedium,
                        maxLines = 1
                    )
                },
                leadingIcon = {
                    Icon(
                        imageVector = FeatherIcons.Search,
                        contentDescription = stringResource(Res.string.search_icon_desc),
                        tint = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                },
                trailingIcon = {
                    if (searchQuery.isNotEmpty()) {
                        IconButton(
                            onClick = { searchQuery = "" },
                            modifier = Modifier.semantics { testTag = "compendio_btn_clear_search" }
                        ) {
                            Icon(
                                imageVector = FeatherIcons.X,
                                contentDescription = stringResource(Res.string.clear_search_desc),
                                tint = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                    }
                },
                shape = RoundedCornerShape(12.dp),
                singleLine = true,
                colors = OutlinedTextFieldDefaults.colors(
                    focusedBorderColor = MaterialTheme.colorScheme.primary,
                    unfocusedBorderColor = MaterialTheme.colorScheme.outline.copy(alpha = 0.5f),
                    focusedContainerColor = MaterialTheme.colorScheme.surface,
                    unfocusedContainerColor = MaterialTheme.colorScheme.surface
                )
            )

            // Row dei Filtri Chip
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 4.dp)
                    .padding(bottom = 8.dp)
                    .horizontalScroll(rememberScrollState()),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                val favCount = if (selectedTab == 0) {
                    uiState.hieros.count { uiState.userData.favoriteHieros.contains(it.gardinerCode) }
                } else if (selectedTab == 1) {
                    compendioWords.count { uiState.userData.favoriteWords.contains(it.id) }
                } else {
                    0
                }
                if (selectedTab != 2 && selectedTab != 3) {
                    CompendioFilterChip(
                        text = stringResource(Res.string.tab_favorites, favCount),
                        selected = showOnlyFavorites,
                        onClick = { showOnlyFavorites = !showOnlyFavorites }
                    )
                }

                val seenCount = if (selectedTab == 0) {
                    seenHieroCodes.size
                } else if (selectedTab == 1) {
                    seenCompendioWordsCount
                } else if (selectedTab == 2) {
                    unlockedRulesCount
                } else {
                    unlockedCompendioImagesCount
                }
                CompendioFilterChip(
                    text = stringResource(Res.string.tab_unlocked, seenCount),
                    selected = showOnlySeen,
                    onClick = {
                        val next = !showOnlySeen
                        showOnlySeen = next
                        if (next) showOnlyLocked = false
                    }
                )

                val lockedCount = if (selectedTab == 0) {
                    maxOf(0, uiState.hieros.size - seenHieroCodes.size)
                } else if (selectedTab == 1) {
                    maxOf(0, compendioWords.size - seenCompendioWordsCount)
                } else if (selectedTab == 2) {
                    maxOf(0, compendioRules.size - unlockedRulesCount)
                } else {
                    maxOf(0, compendioImages.size - unlockedCompendioImagesCount)
                }
                CompendioFilterChip(
                    text = stringResource(Res.string.tab_locked, lockedCount),
                    selected = showOnlyLocked,
                    onClick = {
                        val next = !showOnlyLocked
                        showOnlyLocked = next
                        if (next) showOnlySeen = false
                    }
                )
            }
        }

        // Contenuto in base al tab selezionato
        Box(modifier = Modifier.fillMaxSize().weight(1f)) {
            if (selectedTab == 0) {
                // TAB GEROGLIFICI
                val filteredHieros = remember(
                    searchQuery,
                    uiState.hieros,
                    showOnlyFavorites,
                    showOnlySeen,
                    showOnlyLocked,
                    uiState.userData.favoriteHieros,
                    seenHieroCodes,
                    languageCode
                ) {
                    var list = uiState.hieros

                    if (showOnlyFavorites) {
                        list =
                            list.filter { uiState.userData.favoriteHieros.contains(it.gardinerCode) }
                    }

                    if (showOnlySeen) {
                        list = list.filter { seenHieroCodes.contains(it.gardinerCode) }
                    }

                    if (showOnlyLocked) {
                        list = list.filter { !seenHieroCodes.contains(it.gardinerCode) }
                    }

                    if (searchQuery.isNotBlank()) {
                        val query = searchQuery.lowercase().trim()
                        list = list.filter {
                            it.gardinerCode.lowercase().contains(query) ||
                                    it.unicode.contains(query) ||
                                    it.transliteration.lowercase().contains(query) ||
                                    it.getIdeogramma(languageCode).lowercase().contains(query) ||
                                    it.getIdeogramma("en").lowercase().contains(query) ||
                                    it.getIdeogramma("it").lowercase().contains(query) ||
                                    it.getDeterminativo(languageCode).lowercase().contains(query) ||
                                    it.getDeterminativo("en").lowercase().contains(query) ||
                                    it.getDeterminativo("it").lowercase().contains(query)
                        }
                    }
                    list
                }

                if (filteredHieros.isEmpty()) {
                    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        Text(
                            text = stringResource(Res.string.no_hiero_found),
                            style = MaterialTheme.typography.bodyLarge,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                } else {
                    // Raggruppamento per Gardiner Category e ordinamento naturale interno
                    val groupedHieros = remember(filteredHieros) {
                        filteredHieros
                            .groupBy { code ->
                                val firstTwo = if (code.gardinerCode.startsWith(
                                        "Aa",
                                        ignoreCase = true
                                    )
                                ) "Aa" else code.gardinerCode.take(1).uppercase()
                                firstTwo
                            }
                            .mapValues { entry ->
                                entry.value.sortedWith { h1, h2 ->
                                    val parts1 = parseGardinerCode(h1.gardinerCode)
                                    val parts2 = parseGardinerCode(h2.gardinerCode)
                                    parts1.compareTo(parts2)
                                }
                            }
                    }
                    val deviceInfo = rememberDeviceInfo()


                    LazyColumn(
                        modifier = Modifier.fillMaxSize(),
                        contentPadding = PaddingValues(bottom = 16.dp)
                    ) {
                        if (deviceInfo.isLandscape && deviceInfo.isPhone) {
                            item {
                                OutlinedTextField(
                                    value = searchQuery,
                                    onValueChange = { searchQuery = it },
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(horizontal = 16.dp, vertical = 12.dp),
                                    placeholder = {
                                        Text(
                                            stringResource(Res.string.search_compendium_placeholder),
                                            style = MaterialTheme.typography.bodyMedium,
                                            maxLines = 1
                                        )
                                    },
                                    leadingIcon = {
                                        Icon(
                                            imageVector = FeatherIcons.Search,
                                            contentDescription = stringResource(Res.string.search_icon_desc),
                                            tint = MaterialTheme.colorScheme.onSurfaceVariant
                                        )
                                    },
                                    trailingIcon = {
                                        if (searchQuery.isNotEmpty()) {
                                            IconButton(
                                                onClick = { searchQuery = "" },
                                                modifier = Modifier.semantics {
                                                    testTag = "compendio_btn_clear_search"
                                                }
                                            ) {
                                                Icon(
                                                    imageVector = FeatherIcons.X,
                                                    contentDescription = stringResource(Res.string.clear_search_desc),
                                                    tint = MaterialTheme.colorScheme.onSurfaceVariant
                                                )
                                            }
                                        }
                                    },
                                    shape = RoundedCornerShape(12.dp),
                                    singleLine = true,
                                    colors = OutlinedTextFieldDefaults.colors(
                                        focusedBorderColor = MaterialTheme.colorScheme.primary,
                                        unfocusedBorderColor = MaterialTheme.colorScheme.outline.copy(
                                            alpha = 0.5f
                                        ),
                                        focusedContainerColor = MaterialTheme.colorScheme.surface,
                                        unfocusedContainerColor = MaterialTheme.colorScheme.surface
                                    )
                                )
                            }
                            item {
                                // Row dei Filtri Chip
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(horizontal = 16.dp, vertical = 4.dp)
                                        .padding(bottom = 8.dp)
                                        .horizontalScroll(rememberScrollState()),
                                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    val favCount = if (selectedTab == 0) {
                                        uiState.hieros.count {
                                            uiState.userData.favoriteHieros.contains(
                                                it.gardinerCode
                                            )
                                        }
                                    } else {
                                        compendioWords.count {
                                            uiState.userData.favoriteWords.contains(
                                                it.id
                                            )
                                        }
                                    }
                                    CompendioFilterChip(
                                        text = stringResource(Res.string.tab_favorites, favCount),
                                        selected = showOnlyFavorites,
                                        onClick = { showOnlyFavorites = !showOnlyFavorites }
                                    )

                                    val seenCount = if (selectedTab == 0) {
                                        seenHieroCodes.size
                                    } else {
                                        seenCompendioWordsCount
                                    }
                                    CompendioFilterChip(
                                        text = stringResource(Res.string.tab_unlocked, seenCount),
                                        selected = showOnlySeen,
                                        onClick = {
                                            val next = !showOnlySeen
                                            showOnlySeen = next
                                            if (next) showOnlyLocked = false
                                        }
                                    )

                                    val lockedCount = if (selectedTab == 0) {
                                        maxOf(0, uiState.hieros.size - seenHieroCodes.size)
                                    } else {
                                        maxOf(0, compendioWords.size - seenCompendioWordsCount)
                                    }
                                    CompendioFilterChip(
                                        text = stringResource(Res.string.tab_locked, lockedCount),
                                        selected = showOnlyLocked,
                                        onClick = {
                                            val next = !showOnlyLocked
                                            showOnlyLocked = next
                                            if (next) showOnlySeen = false
                                        }
                                    )
                                }
                            }
                        }
                        gardinerCategories.forEach { categoryPair ->
                            val categoryPrefix = categoryPair.first
                            val categoryName = categoryPair.second
                            val listForCategory = groupedHieros[categoryPrefix]

                            if (!listForCategory.isNullOrEmpty()) {
                                stickyHeader {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .background(MaterialTheme.colorScheme.surfaceVariant)
                                            .padding(horizontal = 16.dp, vertical = 8.dp)
                                    ) {
                                        Text(
                                            text = categoryName,
                                            style = MaterialTheme.typography.titleSmall.copy(
                                                fontWeight = FontWeight.Bold
                                            ),
                                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                    }
                                }


                                // Layout a griglia chunked con N colonne per riga
                                val numberOfColumn = if (deviceInfo.isPortrait) {
                                    when (deviceInfo.deviceClass) {
                                        DeviceClass.PHONE_SMALL -> 6
                                        DeviceClass.PHONE_MEDIUM -> 5
                                        DeviceClass.PHONE_LARGE -> 5
                                        DeviceClass.TABLET_MEDIUM -> 8
                                        DeviceClass.TABLET_LARGE -> 10
                                        // Halved vs. tablet: the web layout's content column is
                                        // much narrower than a tablet screen, so the same column
                                        // count made the glyphs render too small.
                                        DeviceClass.WEB_FULL -> 5
                                    }
                                } else {
                                    when (deviceInfo.deviceClass) {
                                        DeviceClass.PHONE_SMALL -> 8
                                        DeviceClass.PHONE_MEDIUM -> 8
                                        DeviceClass.PHONE_LARGE -> 8
                                        DeviceClass.TABLET_MEDIUM -> 12
                                        DeviceClass.TABLET_LARGE -> 16
                                        DeviceClass.WEB_FULL -> 8
                                    }
                                }
                                val chunkedList = listForCategory.chunked(numberOfColumn)
                                items(chunkedList) { rowItems ->
                                    Row(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .padding(horizontal = 12.dp, vertical = 4.dp),
                                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                                    ) {
                                        for (i in 0 until numberOfColumn) {
                                            if (i < rowItems.size) {
                                                val hiero = rowItems[i]
                                                val isSeen =
                                                    seenHieroCodes.contains(hiero.gardinerCode)
                                                val isFavorite =
                                                    uiState.userData.favoriteHieros.contains(hiero.gardinerCode)

                                                HieroItemCard(
                                                    hiero = hiero,
                                                    seen = isSeen,
                                                    isFavorite = isFavorite,
                                                    onClick = { activeHieroDetails = hiero },
                                                    modifier = Modifier.weight(1f)
                                                )
                                            } else {
                                                // Pad per righe non piene per mantenere allineamento e dimensioni
                                                Spacer(modifier = Modifier.weight(1f))
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else if (selectedTab == 1) {
                // TAB PAROLE
                val filteredWords = remember(
                    searchQuery,
                    compendioWords,
                    showOnlyFavorites,
                    showOnlySeen,
                    showOnlyLocked,
                    uiState.userData.favoriteWords,
                    seenWordIds,
                    languageCode
                ) {
                    var list = compendioWords.sortedBy {
                        it.getMeaning(languageCode)
                            .let { if (languageCode == "de") it else it.lowercase() }
                    }

                    if (showOnlyFavorites) {
                        list = list.filter { uiState.userData.favoriteWords.contains(it.id) }
                    }

                    if (showOnlySeen) {
                        list = list.filter { isWordSeen(it) }
                    }

                    if (showOnlyLocked) {
                        list = list.filter { !isWordSeen(it) }
                    }

                    if (searchQuery.isNotBlank()) {
                        val query = searchQuery.lowercase().trim()
                        list = list.filter {
                            isWordSeen(it) && (
                                    it.getRawMeaning(languageCode).lowercase().contains(query) ||
                                            it.getRawMeaning("en").lowercase().contains(query) ||
                                            it.getRawMeaning("it").lowercase().contains(query) ||
                                            it.reading.lowercase().contains(query) ||
                                            it.gardiner.lowercase().contains(query) ||
                                            it.id.lowercase().contains(query)
                                    )
                        }
                    }
                    list
                }

                if (filteredWords.isEmpty()) {
                    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        Text(
                            text = stringResource(Res.string.no_word_found),
                            style = MaterialTheme.typography.bodyLarge,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                } else {
                    LazyColumn(
                        modifier = Modifier.fillMaxSize(),
                        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        items(filteredWords) { word ->
                            val isSeen = isWordSeen(word)
                            val isFavorite = uiState.userData.favoriteWords.contains(word.id)
                            WordItemCard(
                                word = word,
                                seen = isSeen,
                                languageCode = languageCode,
                                isFavorite = isFavorite,
                                onClick = { activeWordDetails = word }
                            )
                        }
                    }
                }
            } else if (selectedTab == 2) {
                // TAB REGOLE
                fun isRuleUnlocked(rule: CompendioRuleItem): Boolean {
                    return (uiState.userData.stars[rule.lessonId] ?: 0) > 0
                }

                val ruleTitles = compendioRules.associateWith { stringResource(it.title) }

                val filteredRules = remember(
                    searchQuery,
                    showOnlySeen,
                    showOnlyLocked,
                    uiState.userData.stars,
                    ruleTitles
                ) {
                    var list = compendioRules

                    if (showOnlySeen) {
                        list = list.filter { isRuleUnlocked(it) }
                    }

                    if (showOnlyLocked) {
                        list = list.filter { !isRuleUnlocked(it) }
                    }

                    if (searchQuery.isNotBlank()) {
                        val query = searchQuery.lowercase().trim()
                        list = list.filter {
                            isRuleUnlocked(it) && ruleTitles[it].orEmpty().lowercase()
                                .contains(query)
                        }
                    }
                    list
                }

                if (filteredRules.isEmpty()) {
                    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        Text(
                            text = stringResource(Res.string.no_rule_found),
                            style = MaterialTheme.typography.bodyLarge,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                } else {
                    LazyColumn(
                        modifier = Modifier.fillMaxSize(),
                        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        items(filteredRules) { rule ->
                            val isUnlocked = isRuleUnlocked(rule)
                            RuleItemCard(
                                item = rule,
                                isUnlocked = isUnlocked,
                                onClick = { if (isUnlocked) onRuleClick(rule.id) }
                            )
                        }
                    }
                }
            } else {
                // TAB IMMAGINI
                val filteredImages = remember(
                    searchQuery,
                    showOnlySeen,
                    showOnlyLocked,
                    uiState.userData.stars,
                    languageCode
                ) {
                    var list = compendioImages

                    if (showOnlySeen) {
                        list = list.filter {
                            (uiState.userData.stars[it.lessonId] ?: 0) > 0
                        }
                    }

                    if (showOnlyLocked) {
                        list = list.filter {
                            (uiState.userData.stars[it.lessonId] ?: 0) <= 0
                        }
                    }

                    if (searchQuery.isNotBlank()) {
                        val query = searchQuery.lowercase().trim()
                        list = list.filter {
                            val title =
                                it.title(languageCode)
                            title.lowercase().contains(query)
                        }
                    }

                    list
                }

                if (filteredImages.isEmpty()) {
                    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        Text(
                            text = when (languageCode) {
                                "it" -> "Nessuna immagine trovata"
                                "de" -> "Kein Bild gefunden"
                                "es" -> "No se encontraron imágenes"
                                "fr" -> "Aucune image trouvée"
                                else -> "No image found"
                            },
                            style = MaterialTheme.typography.bodyLarge,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                } else {
                    val deviceInfo = rememberDeviceInfo()
                    val numberOfColumns = if (deviceInfo.isPortrait) {
                        when (deviceInfo.deviceClass) {
                            DeviceClass.PHONE_SMALL -> 2
                            DeviceClass.PHONE_MEDIUM -> 2
                            DeviceClass.PHONE_LARGE -> 2
                            DeviceClass.TABLET_MEDIUM -> 3
                            DeviceClass.TABLET_LARGE -> 4
                            DeviceClass.WEB_FULL -> 4
                        }
                    } else {
                        when (deviceInfo.deviceClass) {
                            DeviceClass.PHONE_SMALL -> 3
                            DeviceClass.PHONE_MEDIUM -> 3
                            DeviceClass.PHONE_LARGE -> 3
                            DeviceClass.TABLET_MEDIUM -> 4
                            DeviceClass.TABLET_LARGE -> 5
                            DeviceClass.WEB_FULL -> 5
                        }
                    }

                    LazyColumn(
                        modifier = Modifier.fillMaxSize(),
                        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        items(filteredImages.chunked(numberOfColumns)) { rowItems ->
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.spacedBy(8.dp)
                            ) {
                                for (i in 0 until numberOfColumns) {
                                    if (i < rowItems.size) {
                                        val imageItem = rowItems[i]
                                        val isUnlocked =
                                            (uiState.userData.stars[imageItem.lessonId]
                                                ?: 0) > 0
                                        CompendioImageCard(
                                            item = imageItem,
                                            isUnlocked = isUnlocked,
                                            languageCode = languageCode,
                                            onClick = {
                                                if (isUnlocked) {
                                                    activeImage = imageItem
                                                    showImagePopup.value = true
                                                }
                                            },
                                            modifier = Modifier.weight(1f).aspectRatio(1f)
                                        )
                                    } else {
                                        Spacer(modifier = Modifier.weight(1f))
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    // Dialogo Dettaglio Geroglifico
    activeHieroDetails?.let { hiero ->
        val isSeen = seenHieroCodes.contains(hiero.gardinerCode)
        val isFavorite = uiState.userData.favoriteHieros.contains(hiero.gardinerCode)
        HieroDetailDialog(
            hiero = hiero,
            seen = isSeen,
            isFavorite = isFavorite,
            onToggleFavorite = { onToggleFavoriteHiero(hiero.gardinerCode) },
            onDismiss = { activeHieroDetails = null },
            languageCode = uiState.userData.language.ifBlank { systemLanguageCode() }
        )
    }

    // Dialogo Dettaglio Parola
    activeWordDetails?.let { word ->
        val isSeen = isWordSeen(word)
        val isFavorite = uiState.userData.favoriteWords.contains(word.id)
        WordDetailDialog(
            word = word,
            seen = isSeen,
            isFavorite = isFavorite,
            languageCode = languageCode,
            onToggleFavorite = { onToggleFavoriteWord(word.id) },
            onDismiss = { activeWordDetails = null }
        )
    }

    activeImage?.let { imageItem ->
        if (showImagePopup.value) {
            val imageTitle = imageItem.title(languageCode)
            ImagePopup(
                showFullscreenImage = showImagePopup,
                resource = imageItem.image,
                contentDescription = imageTitle,
                applyFilter = false,
                title = imageTitle,
                description = imageItem.description?.let { stringResource(it) }
            )
        }
        if (!showImagePopup.value) {
            activeImage = null
        }
    }
}

@Composable
private fun CompendioImageCard(
    item: CompendioImageItem,
    isUnlocked: Boolean,
    languageCode: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val containerColor = if (isUnlocked) {
        MaterialTheme.colorScheme.surfaceContainer
    } else {
        MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.5f)
    }

    val borderColor = if (isUnlocked) {
        MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f)
    } else {
        MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.2f)
    }

    val imageTitle = item.title(languageCode)

    Surface(
        modifier = modifier
            .clip(RoundedCornerShape(12.dp))
            .clickable(onClick = onClick)
            .semantics { testTag = "compendio_image_clickable_${item.id}" },
        shape = RoundedCornerShape(12.dp),
        color = containerColor,
        tonalElevation = 1.dp,
        shadowElevation = 0.dp,
        border = androidx.compose.foundation.BorderStroke(1.5.dp, borderColor)
    ) {
        // Image only: the title stays as contentDescription and search key.
        Box(modifier = Modifier.fillMaxSize().padding(8.dp)) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .clip(RoundedCornerShape(10.dp))
                    .background(MaterialTheme.colorScheme.surface)
            ) {
                Image(
                    painter = painterResource(item.image),
                    contentDescription = imageTitle,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(2.dp)
                        .clip(RoundedCornerShape(8.dp))
                )

                if (!isUnlocked) {
                    Box(
                        modifier = Modifier
                            .matchParentSize()
                            .background(MaterialTheme.colorScheme.scrim.copy(alpha = 0.9f)),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            text = when (languageCode) {
                                "it" -> "Bloccata"
                                "de" -> "Gesperrt"
                                "es" -> "Bloqueada"
                                "fr" -> "Verrouillée"
                                else -> "Locked"
                            },
                            color = MaterialTheme.colorScheme.onPrimary,
                            style = MaterialTheme.typography.labelLarge.copy(fontWeight = FontWeight.Bold)
                        )
                    }
                }
            }
        }
    }
}

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun CompendioScreenContentPreview() {
    val previewState = LandingUiState(
        userData = UserData(
            favoriteHieros = setOf("A1", "C1"),
            favoriteWords = setOf("w2", "w3"),
            language = "it"
        ),
        hieros = listOf(
            Hiero("A1", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A1", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A1", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A1", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A2", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A1", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A1", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A2", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("A2", "𓀀", "j", "uomo", "Uomo", "-", "man", "Man", "-"),
            Hiero("B1", "𓁐", "st", "donna", "Donna", "-", "woman", "Woman", "-"),
            Hiero("C1", "𓀭", "ntr", "dio", "Divinità", "-", "god", "Deity", "-"),
            Hiero("D2", "𓂧", "drt", "mano", "Mano", "-", "hand", "Hand", "-"),
            Hiero("E1", "𓃠", "mjw", "gatto", "Gatto", "-", "cat", "Cat", "-")
        ),
        words = listOf(
            Word(
                "w1",
                "uomo",
                "zj",
                "A1",
                "Nota descrittiva uomo",
                null,
                null,
                "l'",
                "dell'",
                true,
                "man",
                "of the man"
            ),
            Word(
                "w2",
                "donna",
                "st",
                "B1",
                "Nota descrittiva donna",
                "B1:Z1",
                null,
                "la",
                "della",
                true,
                "woman",
                "of the woman"
            ),
            Word(
                "w3",
                "dio",
                "ntr",
                "C1",
                "Nota descrittiva divinità",
                "C1:Z1",
                null,
                "il",
                "del",
                true,
                "god",
                "of the god"
            ),
            Word(
                "w4",
                "gatto",
                "mjw",
                "E1",
                "Nota descrittiva gatto",
                "E1:Z1",
                null,
                "il",
                "del",
                true,
                "cat",
                "of the cat"
            )
        )
    )

    AppTheme {
        Surface {
            CompendioScreenContent(
                uiState = previewState,
                seenHieroCodes = setOf("A1", "B1", "E1"),
                seenWordIds = setOf("w1", "w2"),
                onToggleFavoriteHiero = {},
                onToggleFavoriteWord = {},
                onWordViewed = {},
                onHieroViewed = {}
            )
        }
    }
}

@Composable
private fun CompendioFilterChip(
    text: String,
    selected: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val containerColor =
        if (selected) MaterialTheme.colorScheme.primaryContainer else MaterialTheme.colorScheme.surface
    val contentColor =
        if (selected) MaterialTheme.colorScheme.onPrimaryContainer else MaterialTheme.colorScheme.onSurfaceVariant
    val borderColor =
        if (selected) MaterialTheme.colorScheme.outlineVariant else MaterialTheme.colorScheme.outline.copy(
            alpha = 0.3f
        )

    val hapticFeedback = LocalHapticFeedback.current
    Box(
        modifier = modifier
            .background(color = containerColor, shape = RoundedCornerShape(16.dp))
            .border(width = 1.dp, color = borderColor, shape = RoundedCornerShape(16.dp))
            .clip(RoundedCornerShape(16.dp))
            .clickable {
                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                onClick()
            }
            .semantics {
                testTag = "compendio_filter_clickable_${text.lowercase().replace(" ", "_")}"
            }
            .padding(horizontal = 12.dp, vertical = 6.dp),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = text,
            style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold),
            color = contentColor
        )
    }
}
